(function(){"use strict";if(window.__MAXTON_INTEGRATION__)return;window.__MAXTON_INTEGRATION__=!0;var html=document.documentElement,frame=0,observed=new Set,redoRoots=new WeakSet,resize=typeof ResizeObserver=="function"?new ResizeObserver(schedule):null,productSaleSelector="[data-maxton-product-sale]";function saleElementVisible(element){if(!element||!element.isConnected||!element.getClientRects().length)return!1;for(var current=element;current;current=current.parentElement){var style=getComputedStyle(current);if(current.hidden||style.display==="none"||style.visibility==="hidden"||style.visibility==="collapse"||Number(style.opacity)===0)return!1}return!0}function saleText(element){return element?element.textContent.replace(/\s+/g," ").trim():""}/* Inserted inside the existing Maxton integration IIFE. Campaigns are public,
   server-published display data; this code never accesses Shopify Admin. */
var campaignData = null, campaignClockOffset = 0, campaignTick = 0,
    campaignPoll = 0, campaignFetching = false, campaignDismissed = "",
    campaignCurrent = null, campaignNodes = null,
    campaignOwnSelector = "[data-maxton-product-sale], #maxton-campaign-background, #maxton-campaign-spacer";

function campaignTimestamp(value, optional) {
  if (value === null || value === undefined || value === "") return optional ? null : NaN;
  if (typeof value === "number") return Number.isFinite(value) ? (Math.abs(value) < 1e12 ? value * 1000 : value) : NaN;
  if (typeof value !== "string") return NaN;
  return /^\d+(?:\.\d+)?$/.test(value) ? campaignTimestamp(Number(value), optional) : Date.parse(value);
}

function campaignNow() { return Date.now() + campaignClockOffset; }
function campaignText(value) { return typeof value === "string" ? value.trim() : ""; }

function acceptCampaignPayload(payload) {
  if (!payload || typeof payload !== "object") return false;
  var data = payload.data;
  if (typeof data === "string") {
    try { data = JSON.parse(data); } catch (_) { return false; }
  }
  if (!data || data.version !== 1 || !Array.isArray(data.campaigns)) return false;
  var normalized = [];
  data.campaigns.forEach(function(item) {
    if (!item || typeof item !== "object") return;
    var title = campaignText(item.title), starts = campaignTimestamp(item.startsAt, true),
        ends = campaignTimestamp(item.endsAt, true), priority = Number(item.priority);
    if (!title || (starts !== null && !Number.isFinite(starts)) ||
        (ends !== null && !Number.isFinite(ends)) ||
        (starts !== null && ends !== null && ends <= starts)) return;
    normalized.push({
      id: String(item.id || title), title: title, offer: campaignText(item.offer),
      terms: campaignText(item.terms), starts: starts === null ? 0 : starts, ends: ends,
      priority: Number.isFinite(priority) ? priority : 0, link: campaignText(item.link)
    });
  });
  var serverTime = campaignTimestamp(payload.serverTime, true);
  if (Number.isFinite(serverTime)) campaignClockOffset = serverTime - Date.now();
  campaignData = normalized;
  html.setAttribute("data-maxton-campaign-managed", "");
  schedule();
  return true;
}

function readInitialCampaignData() {
  var source = document.getElementById("maxton-sale-data");
  if (source) {
    try { acceptCampaignPayload(JSON.parse(source.textContent)); } catch (_) {}
  }
}

function pollCampaignData() {
  if (campaignFetching || typeof fetch !== "function") return;
  campaignFetching = true;
  var controller = typeof AbortController === "function" ? new AbortController() : null,
      timeout = controller ? window.setTimeout(function() { controller.abort(); }, 15000) : 0,
      options = {
    cache: "no-store", credentials: "omit", headers: { Accept: "application/json" }
  };
  if (controller) options.signal = controller.signal;
  fetch("/?view=maxton-promotions", options).then(function(response) {
    if (!response.ok) throw new Error("Campaign response unavailable");
    return response.json();
  }).then(acceptCampaignPayload).catch(function() {
    /* Retain the last valid public payload. Local expiry still runs. */
  }).finally(function() {
    if (timeout) window.clearTimeout(timeout);
    campaignFetching = false;
  });
}

function startCampaignData() {
  readInitialCampaignData();
  campaignPoll = window.setInterval(pollCampaignData, 60000);
  window.addEventListener("pageshow", function(event) {
    if (event.persisted) { schedule(); pollCampaignData(); }
  });
  document.addEventListener("visibilitychange", function() {
    if (!document.hidden) { schedule(); pollCampaignData(); }
  });
}

function selectedCampaign(now) {
  if (campaignData === null) return null;
  return campaignData.filter(function(item) {
    return item.starts <= now && (item.ends === null || now < item.ends);
  }).sort(function(a, b) {
    var lexical = function(left, right) { return left === right ? 0 : left < right ? -1 : 1; };
    return b.priority - a.priority || b.starts - a.starts || lexical(a.id, b.id) || lexical(a.title, b.title);
  })[0] || null;
}

function campaignKey(campaign) {
  return campaign.id + "|" + campaign.starts + "|" + campaign.ends + "|" + campaign.title;
}

function campaignUnits(campaign, now) {
  if (campaign.ends === null) return [];
  var seconds = Math.max(0, Math.ceil((campaign.ends - now) / 1000));
  return [
    {unit: "days", value: String(Math.floor(seconds / 86400)), label: "DAYS"},
    {unit: "hours", value: String(Math.floor(seconds % 86400 / 3600)).padStart(2, "0"), label: "HRS"},
    {unit: "minutes", value: String(Math.floor(seconds % 3600 / 60)).padStart(2, "0"), label: "MIN"},
    {unit: "seconds", value: String(seconds % 60).padStart(2, "0"), label: "SEC"}
  ].filter(function(item) { return item.unit !== "days" || Number(item.value) > 0; });
}

function campaignElement(tag, id, parent) {
  var element = document.createElement(tag);
  if (id) element.id = id;
  if (parent) parent.appendChild(element);
  return element;
}

function createCampaignBanner() {
  var spacer = campaignElement("div", "maxton-campaign-spacer"),
      background = campaignElement("section", "maxton-campaign-background"),
      bar = campaignElement("div", "maxton-campaign-bar", background),
      content = campaignElement("div", "maxton-campaign-content", bar),
      message = campaignElement("div", "maxton-campaign-message-one", content),
      label = campaignElement("span", "", message),
      offer = campaignElement("span", "", message),
      timer = campaignElement("div", "maxton-campaign-timer", content),
      grid = campaignElement("div", "maxton-campaign-timer-grid", timer),
      terms = campaignElement("p", "maxton-campaign-message-two", content),
      close = campaignElement("button", "maxton-campaign-close", bar), units = {};
  spacer.setAttribute("data-maxton-sale-spacer", "");
  spacer.setAttribute("aria-hidden", "true");
  background.setAttribute("data-maxton-promo-bar", "");
  background.setAttribute("data-maxton-sale", "");
  background.setAttribute("aria-label", "Active promotion");
  label.setAttribute("data-maxton-sale-label", "");
  offer.setAttribute("data-maxton-sale-offer", "");
  timer.setAttribute("role", "timer");
  timer.setAttribute("aria-live", "off");
  ["days", "hours", "minutes", "seconds"].forEach(function(unit) {
    var group = campaignElement("span", "", grid),
        number = campaignElement("span", "maxton-campaign-" + unit + "-span", group),
        caption = campaignElement("span", "maxton-campaign-" + unit + "-label", group);
    group.className = "maxton-campaign-timer-unit";
    number.className = "maxton-campaign-js-timer-number";
    caption.className = "maxton-campaign-js-timer-label";
    units[unit] = {group: group, number: number, caption: caption};
  });
  close.type = "button";
  close.setAttribute("aria-label", "Dismiss promotion banner");
  close.textContent = "\u00d7";
  close.addEventListener("click", function() {
    if (campaignCurrent) campaignDismissed = campaignKey(campaignCurrent);
    schedule();
  });
  document.body.prepend(spacer, background);
  return {spacer: spacer, background: background, message: message, label: label,
    offer: offer, timer: timer, terms: terms, units: units};
}

function campaignLink(value) {
  if (!value) return "";
  try {
    var url = new URL(value, location.origin);
    return /^https?:$/.test(url.protocol) ? url.href : "";
  } catch (_) { return ""; }
}

function updateCampaignMessageLink(nodes, value) {
  var href = campaignLink(value), link = nodes.message.querySelector("a");
  if (href) {
    if (!link) {
      link = campaignElement("a", "", nodes.message);
      link.append(nodes.label, nodes.offer);
    }
    if (link.getAttribute("href") !== href) link.setAttribute("href", href);
  } else if (link) {
    nodes.message.append(nodes.label, nodes.offer);
    link.remove();
  }
}

function scheduleCampaignBoundary(now, selected) {
  if (campaignTick) window.clearTimeout(campaignTick);
  campaignTick = 0;
  if (campaignData === null) return;
  var delay = Infinity;
  campaignData.forEach(function(item) {
    if (item.starts > now) delay = Math.min(delay, item.starts - now);
    if (item.ends !== null && item.ends > now) delay = Math.min(delay, item.ends - now);
  });
  if (selected && selected.ends !== null) {
    var remaining = selected.ends - now;
    delay = Math.min(delay, remaining % 1000 || 1000);
  }
  if (Number.isFinite(delay)) campaignTick = window.setTimeout(function() {
    campaignTick = 0;
    schedule();
  }, Math.max(1, Math.min(delay, 60000)));
}

function styleCampaignSale() {
  if (campaignData === null) return;
  var now = campaignNow(), selected = selectedCampaign(now);
  campaignCurrent = selected;
  scheduleCampaignBoundary(now, selected);
  if (!selected || campaignDismissed === campaignKey(selected)) {
    if (campaignNodes) {
      campaignNodes.background.remove();
      campaignNodes.spacer.remove();
      campaignNodes = null;
    }
    return;
  }
  if (!campaignNodes || !campaignNodes.background.isConnected) {
    if (campaignNodes) campaignNodes.spacer.remove();
    campaignNodes = createCampaignBanner();
  }
  var nodes = campaignNodes, units = campaignUnits(selected, now),
      order = units.map(function(item) { return item.unit; });
  setProductSaleText(nodes.label, selected.title);
  setProductSaleText(nodes.offer, selected.offer);
  nodes.offer.hidden = !selected.offer;
  setProductSaleText(nodes.terms, selected.terms);
  nodes.terms.hidden = !selected.terms;
  nodes.timer.hidden = !units.length;
  updateCampaignMessageLink(nodes, selected.link);
  Object.keys(nodes.units).forEach(function(unit) {
    nodes.units[unit].group.hidden = order.indexOf(unit) < 0;
  });
  units.forEach(function(item) {
    setProductSaleText(nodes.units[item.unit].number, item.value);
    setProductSaleText(nodes.units[item.unit].caption, item.label);
  });
}

function activeProductSale() {
  if (campaignData !== null) {
    var current = selectedCampaign(campaignNow());
    if (!current || !campaignNodes || !campaignNodes.background.isConnected ||
        campaignDismissed === campaignKey(current)) return null;
    return {label: current.title, offer: current.offer, terms: current.terms,
      units: campaignUnits(current, campaignNow())};
  }
  var bar = document.querySelector("#epb_background[data-maxton-sale]"),
      timer = bar && bar.querySelector("#epb_timer_grid");
  if (!saleElementVisible(bar) || bar.hasAttribute("data-maxton-sale-expired")) return null;
  var label = saleText(bar.querySelector("[data-maxton-sale-label]")),
      offer = saleText(bar.querySelector("[data-maxton-sale-offer]")), units = [], valid = true;
  if (!label) return null;
  if (timer && saleElementVisible(timer)) {
    ["days", "hours", "minutes", "seconds"].forEach(function(unit) {
      var number = timer.querySelector("#epb_" + unit + "_span");
      if (unit === "days" && (!number || !saleElementVisible(number))) return;
      var value = saleText(number);
      if (!number || !saleElementVisible(number) || !/^\d+$/.test(value)) { valid = false; return; }
      var labelIndex = Array.from(timer.querySelectorAll(".epb_js_timer_number")).indexOf(number),
          labelNode = timer.querySelector("#epb_" + unit + "_label") ||
            timer.querySelectorAll(".epb_js_timer_label")[labelIndex];
      if (!labelNode && number.parentElement) labelNode = number.parentElement.querySelector(".epb_js_timer_label");
      units.push({unit: unit, value: value, label: saleText(labelNode) ||
        {days: "DAYS", hours: "HRS", minutes: "MIN", seconds: "SEC"}[unit]});
    });
    if (!valid || !units.some(function(item) { return Number(item.value) > 0; })) return null;
  }
  return {label: label, offer: offer, terms: saleText(bar.querySelector("#epb_message_two")), units: units};
}

function styleFlashSale() {
  if (campaignData !== null) return;
  var bar = document.getElementById("epb_background"),
      message = bar && bar.querySelector("#epb_message_one"),
      timer = bar && bar.querySelector("#epb_timer_grid");
  if (!message) return;
  if (!message.querySelector("[data-maxton-sale-label]")) {
    var text = saleText(message), parts = text.match(/^(.+?)\s+[-\u2013\u2014]\s+(.+)$/),
        label = document.createElement("span"), offer = document.createElement("span");
    if (!text) return;
    label.setAttribute("data-maxton-sale-label", "");
    label.textContent = parts ? parts[1] : text;
    offer.setAttribute("data-maxton-sale-offer", "");
    offer.textContent = parts ? parts[2].replace(/\bUP\s*TO\b/i, "Up to").replace(/\bOFF\b/i, "off") : "";
    offer.hidden = !offer.textContent;
    message.replaceChildren(label, document.createTextNode(" "), offer);
  }
  bar.setAttribute("data-maxton-sale", "");
  if (timer) {
    var values = ["hours", "minutes", "seconds"].map(function(unit) {
      var number = timer.querySelector("#epb_" + unit + "_span");
      return number && /^\d+$/.test(saleText(number)) ? Number(saleText(number)) : NaN;
    }), days = timer.querySelector("#epb_days_span"), daysValue = days ? Number(saleText(days)) : 0;
    if (values.every(Number.isFinite) && Number.isFinite(daysValue)) {
      if (values.every(function(value) { return value === 0; }) && daysValue === 0)
        bar.setAttribute("data-maxton-sale-expired", "");
      else bar.removeAttribute("data-maxton-sale-expired");
    }
  }
}

function updateProductSale(panel, sale) {
  if (panel.getAttribute("aria-label") !== sale.label) panel.setAttribute("aria-label", sale.label);
  panel.setAttribute("data-maxton-campaign-mirror", "");
  setProductSaleText(panel.querySelector("[data-maxton-product-sale-label]"), sale.label);
  var offer = panel.querySelector("[data-maxton-product-sale-offer]");
  setProductSaleText(offer, sale.offer);
  offer.hidden = !sale.offer;
  var terms = panel.querySelector("[data-maxton-product-sale-terms]");
  setProductSaleText(terms, sale.terms);
  terms.hidden = !sale.terms;
  var countdown = panel.querySelector("[data-maxton-product-sale-countdown]"),
      order = sale.units.map(function(item) { return item.unit; }).join(",");
  countdown.hidden = !sale.units.length;
  if (countdown.getAttribute("data-maxton-product-sale-units") !== order) {
    countdown.replaceChildren();
    sale.units.forEach(function(item) {
      var group = productSaleNode("span", "data-maxton-product-sale-unit", countdown);
      group.setAttribute("data-maxton-product-sale-unit", item.unit);
      productSaleNode("span", "data-maxton-product-sale-value", group);
      productSaleNode("span", "data-maxton-product-sale-unit-label", group);
    });
    countdown.setAttribute("data-maxton-product-sale-units", order);
  }
  Array.from(countdown.children).forEach(function(group, index) {
    setProductSaleText(group.querySelector("[data-maxton-product-sale-value]"), sale.units[index].value);
    setProductSaleText(group.querySelector("[data-maxton-product-sale-unit-label]"), sale.units[index].label);
  });
}

function productSaleOwnMutation(record) {
  var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
  if (target && target.closest(campaignOwnSelector)) return true;
  if (target === html && record.type === "attributes" && record.attributeName === "style") {
    var withoutOffsets = function(value) {
      return (value || "").replace(/--maxton-(?:promo-offset|header-height)\s*:[^;]*(?:;|$)/g, "").trim();
    };
    if (withoutOffsets(record.oldValue) === withoutOffsets(html.getAttribute("style"))) return true;
  }
  if (record.type !== "childList") return false;
  var changed = Array.from(record.addedNodes).concat(Array.from(record.removedNodes));
  return changed.length > 0 && changed.every(function(node) {
    return node.nodeType === 1 && node.matches(campaignOwnSelector);
  });
}

function productSaleNode(tag,attribute,parent){var node=document.createElement(tag);return node.setAttribute(attribute,""),parent&&parent.appendChild(node),node}function setProductSaleText(node,value){node.textContent!==value&&(node.textContent=value)}function createProductSale(){var panel=productSaleNode("section","data-maxton-product-sale"),heading=productSaleNode("div","data-maxton-product-sale-heading",panel);productSaleNode("span","data-maxton-product-sale-label",heading),productSaleNode("strong","data-maxton-product-sale-offer",heading);var countdown=productSaleNode("div","data-maxton-product-sale-countdown",panel);return countdown.setAttribute("role","timer"),countdown.setAttribute("aria-live","off"),productSaleNode("p","data-maxton-product-sale-terms",panel),panel}function styleProductFlashSale(){var sale=activeProductSale(),prices=Array.from(document.querySelectorAll(".product-information .detail-price")).filter(saleElementVisible),kept=new Set;sale&&prices.forEach(function(price){var panel=price.nextElementSibling;!panel||!panel.matches(productSaleSelector)?(panel=createProductSale(),updateProductSale(panel,sale),price.insertAdjacentElement("afterend",panel)):updateProductSale(panel,sale),kept.add(panel)}),document.querySelectorAll(productSaleSelector).forEach(function(panel){kept.has(panel)||panel.remove()})}function productSaleRelevantMutation(record){if(productSaleOwnMutation(record))return!1;if(record.type==="childList")return!0;var target=record.target.nodeType===1?record.target:record.target.parentElement;return target?target.closest("#epb_background, #epb_container, [data-maxton-promo-bar]")?!0:record.type==="attributes"&&(target.matches(".site-header, .product-information, .detail-price")||target.querySelector("#epb_background, .product-information .detail-price")):!1}function styleRedoCheckout(){document.querySelectorAll(".cart-summary redo-shopify-toggle").forEach(function(toggle){var root=toggle.root;if(!(!root||root===toggle)&&(redoRoots.has(root)||(redoRoots.add(root),new MutationObserver(schedule).observe(root,{childList:!0})),!root.querySelector("style[data-maxton-redo-checkout]"))){var style=document.createElement("style");style.setAttribute("data-maxton-redo-checkout",""),style.textContent='[data-target="non-coverage-button"] { background-color: var(--maxton-redo-secondary-background, transparent) !important; }',root.appendChild(style)}})}function update(){frame=0,styleRedoCheckout(),styleCampaignSale(),styleFlashSale(),styleProductFlashSale();var bars=Array.from(document.querySelectorAll("#epb_background, [data-maxton-promo-bar]")),header=Array.from(document.querySelectorAll(".site-header")).find(function(item){return item.getClientRects().length>0}),offset=0;if(bars.forEach(function(bar){var style=getComputedStyle(bar),rect=bar.getBoundingClientRect(),visibleTopBar=style.position==="fixed"&&style.display!=="none"&&style.visibility!=="hidden"&&Number(style.opacity)>0&&rect.width>0&&rect.height>0&&rect.top<=1&&rect.bottom>0;visibleTopBar&&(offset=Math.max(offset,Math.ceil(rect.bottom)));var spacer=bar.hasAttribute("data-maxton-sale")&&(bar.id==="maxton-campaign-background"?document.getElementById("maxton-campaign-spacer"):bar.closest("#epb_container"));if(spacer&&style.position==="fixed"&&(visibleTopBar||style.top==="0px")){var height=(visibleTopBar?Math.ceil(rect.height):0)+"px";spacer.setAttribute("data-maxton-sale-spacer",""),spacer.style.height!==height&&(spacer.style.height=height)}}),document.querySelectorAll("#epb_container[data-maxton-sale-spacer]").forEach(function(spacer){!spacer.querySelector("#epb_background")&&spacer.style.height!=="0px"&&(spacer.style.height="0px")}),html.style.setProperty("--maxton-promo-offset",offset+"px"),header&&html.style.setProperty("--maxton-header-height",Math.ceil(header.getBoundingClientRect().height)+"px"),resize){var next=new Set(bars.concat(header?[header]:[]));observed.forEach(function(item){next.has(item)||resize.unobserve(item)}),next.forEach(function(item){observed.has(item)||resize.observe(item)}),observed=next}}function schedule(){frame||(frame=requestAnimationFrame(update))}function start(){startCampaignData();window.customElements&&customElements.whenDefined("redo-shopify-toggle").then(schedule),new MutationObserver(function(records){records.some(productSaleRelevantMutation)&&(styleProductFlashSale(),schedule())}).observe(document.body,{childList:!0,subtree:!0,characterData:!0,attributes:!0,attributeOldValue:!0,attributeFilter:["style","class","hidden","aria-hidden"]}),window.addEventListener("resize",schedule,{passive:!0}),schedule()}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",start,{once:!0}):start()})();
